import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { FundCallBanner } from 'src/Components/FundCalls/FundCallBanner';
import useFetchDashboard from 'src/Hooks/Queries/useFetchDashboard';

import { CommunityCard } from '../components/CommunityCard';
import { DashboardHeader } from '../components/DashboardHeader';
import { DashboardHero } from '../components/DashboardHero';
import { EventsCard } from '../components/EventsCard';
import { HomeToDoLine } from '../components/HomeToDoLine';
import { HouseGaugeCard } from '../components/HouseGaugeCard';
import { MyBalanceCard } from '../components/MyBalanceCard';
import { OnboardingChecklist } from '../components/OnboardingChecklist';
import { ProjectsCard } from '../components/ProjectsCard';
import { TasksCard } from '../components/TasksCard';

import styles from './DashboardMainPage.module.scss';

const DashboardMainPage = () => {
  const { t } = useTranslation();
  const { data: dashboard, isLoading } = useFetchDashboard();

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader />
      </div>
    );
  }

  if (!dashboard) {
    return (
      <div className={styles.loading}>
        <p>{t('dashboard.error', 'Impossible de charger le tableau de bord')}</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <DashboardHeader />

      {/* Ne s'affiche que si quelque chose est à verser : un bandeau permanent finit par ne
          plus être lu. */}
      <FundCallBanner />

      {/* Once every onboarding step is done the checklist has nothing left to say. */}
      {dashboard.onboardingCompletionPercent < 100 && (
        <OnboardingChecklist
          steps={dashboard.onboarding}
          completionPercent={dashboard.onboardingCompletionPercent}
        />
      )}

      <HomeToDoLine
        overdueTasks={dashboard.urgentTasks.filter(task => task.isOverdue).length}
        pendingVotes={dashboard.activeProjects.filter(project => project.hasActiveVote).length}
      />

      <div className={styles.heroRow}>
        <DashboardHero nextStay={dashboard.upcomingStays[0]} />
        <MyBalanceCard />
        <HouseGaugeCard finances={dashboard.finances} />
      </div>

      <div className={styles.cardsGrid}>
        <TasksCard tasks={dashboard.urgentTasks} />
        <EventsCard otherEvents={dashboard.upcomingOtherEvents} stays={dashboard.upcomingStays} />
        <ProjectsCard projects={dashboard.activeProjects} />
        <CommunityCard posts={dashboard.recentPosts} albums={dashboard.recentAlbums} />
      </div>

      <Outlet />
    </div>
  );
};

export default DashboardMainPage;
